export default {
    items: [
        {
            name: 'Dashboard',
            url: '/dashboard',
            icon: 'fa fa-dashboard',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
        },
        {
            name: 'Acompanhamento do Protesto',
            url: '/acompanhamento-protesto',
            icon: 'fa fa-dashboard',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
        },
        {
            name: 'Cartas Para Assinar e Emissão em Lote',
            url: '/assinar-cartas-lote',
            icon: 'fa fa-certificate',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
        },
        {
            name: 'Cartas Emitidas e Emissão Individual',
            url: '/emitir-cartas',
            icon: 'fa fa-envelope-o',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
        },
        {
            name: "Pesquisa",
            url: '/consultar-cdas',
            icon: 'fa fa-search',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-CONSULTA', 'PGEPROAJU-CONSULTAEDITAEF']
        },
        {
            name: 'Configurações',
            url: '#',
            icon: 'fa fa-keyboard-o',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-CONSULTAEDITAEF'],
            children: [
                {
                    name: 'UPF/PR',
                    url: '/atualizar-upf-pr',
                    icon: 'fa fa-dollar',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: 'Exceções',
                    url: '/excecoes',
                    icon: 'fa fa-exclamation',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: 'Tabelionato',
                    url: '/tabelionato',
                    icon: 'fa fa-bank',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: 'Comarca',
                    url: '/comarca',
                    icon: 'fa fa-arrows',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: 'Réu Federal',
                    url: '/reu-federal',
                    icon: 'fa fa-user-circle-o',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: 'Usuário',
                    url: '/usuario',
                    icon: 'fa fa-group',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: 'Procurador',
                    url: '/procurador',
                    icon: 'fa fa-black-tie',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: 'Juízo',
                    url: '/juizo',
                    icon: 'fa fa-gavel',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: 'Petição',
                    url: '/peticao',
                    icon: 'fa fa-file-powerpoint-o',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: 'Parâmetros do Sistema',
                    url: '/parametros-sistema',
                    icon: 'fa fa-cogs',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: 'Limite Protestos',
                    url: '/limiteProtestos',
                    icon: 'fa fa-arrows',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: "Processamento Arquivos Pagamento",
                    url: '/processamento-arquivos',
                    icon: 'fa fa-stack-overflow',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                },
                {
                    name: "Migração e Edição de EF",
                    url: '/migracao',
                    icon: 'fa fa-share-square-o',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-CONSULTAEDITAEF']
                },
                {
                    name: 'Tipo de Crédito/Assunto',
                    url: '/tipo-credito-assunto',
                    icon: 'fa fa-share-alt-square',
                    groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA']
                }
            ]
        },
        {
            name: 'Relatório Protesto-Ajuizamento',
            url: '/relatorio-protesto-ajuizamento',
            icon: 'fa fa-pie-chart',
            groups: ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-DIVIDAATIVA', 'PGEPROAJU-RELATORIO']
        },
        {
            name: 'Importar Processos Digitalizados',
            url: '/importar-processos-digitalizados',
            icon: 'fa fa-cogs',
            groups: ['PGEPROAJU-ADMINISTRADOR']
        }
    ]
}
